import { FormBase } from "../../util/form-base-form";

class InstagramEmbedForm extends FormBase {
    public getDebugRoots(root: ParentNode, selector: string): HTMLElement[] {
        return this.queryElements(root, selector, HTMLElement);
    }

    public getInstagramBlockquote(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, "blockquote.instagram-media", HTMLElement);
    }

    public getInstagramAnchor(root: ParentNode): HTMLAnchorElement | null {
        return this.queryElement(root, 'a[href*="instagram.com"]', HTMLAnchorElement);
    }
}

const instagramEmbedForm = new InstagramEmbedForm();

export { instagramEmbedForm };
